exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "structure-tableau .inner-card{min-width:250px;max-width:400px;margin:15px}structure-tableau .card-title{margin-top:15px;margin-left:15px;text-transform:uppercase}", ""]);

